/**
 * BLOCK: FAQ - Schema
 */

import WPSPBlockIcons from '@Controls/block-icons';
import attributes from './attributes';
import edit from './edit';
import save from './save';
import './style.scss';
import deprecated from './deprecated';
import { registerBlockType } from '@wordpress/blocks';
import { withSelect } from '@wordpress/data';
import { compose, createHigherOrderComponent } from '@wordpress/compose';
import { __ } from '@wordpress/i18n';

const { addFilter } = wp.hooks;

/**
 * Override the default block element to add	wrapper props.
 *
 * @param  {Function} BlockListBlock Original component
 * @return {Function} Wrapped component
 */

const enhance = compose(
	withSelect((select) => {
		return {
			selected: select('core/block-editor').getSelectedBlock(),
		};
	})
);
/**
 * Add custom WPSP attributes to selected blocks
 *
 * @param {Function} BlockEdit Original component.
 * @return {string} Wrapped component.
 */
const withFaq = createHigherOrderComponent((BlockEdit) => {
	return enhance(({ ...props }) => {
		return (
			<>
				<BlockEdit {...props} />
			</>
		);
	});
}, 'withFaq');

registerBlockType('wpsp/faq', {
	title: wpsp_blocks_info.blocks['wpsp/faq'].title,
	description: wpsp_blocks_info.blocks['wpsp/faq'].description,
	icon: WPSPBlockIcons.faq,
	category: wpsp_blocks_info.category,
	keywords: [
		__('faq', 'wp-schema-pro'),
		__('schema', 'wp-schema-pro'),
		__('wpsp', 'wp-schema-pro'),
		__('accordion', 'wp-schema-pro'),
	],
	example: {
		innerBlocks: [
			{
				name: 'wpsp/faq-child',
				innerBlocks: [
					{
						name: 'wpsp/faq-child',
						attributes: {
							question: 'What is FAQ?',
							answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
						},
					},
				],
			},
			{
				name: 'wpsp/faq-child',
				innerBlocks: [
					{
						name: 'wpsp/faq-child',
						attributes: {
							question: 'What is FAQ?',
							answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
						},
					},
				],
			},
		],
	},
	attributes,
	deprecated,
	edit,
	supports: {
		anchor: true,
	},
	save,
});

addFilter('editor.BlockEdit', 'wpsp/faq', withFaq);
